import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Text,
} from '@domain-group/suit-theme'

import copyToClipboard from '@functions/copyToClipboard'

interface DownloadReadyProps {
  downloadLink: string,
}

const DownloadReady = (props: DownloadReadyProps) => {
  const { downloadLink } = props

  return (
    <>
      <Box flexDirection="column" lineHeight="1.3" padding="large" variant="whiteGrey">
        <Text fontSize="small">Download Ready</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Your images are ready to download. This download should have already started downloading in your browser. If
          it hasn&apos;t click the download button below.
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Or you can access the download via the link below.
        </Text>
      </Box>

      <Button
        buttonStyle="secondaryEdit"
        icon={<FontAwesomeIcon icon={faClipboard} />}
        // @ts-expect-error TS2322
        marginTop="medium"
        onClick={() => copyToClipboard(downloadLink)}
        size="medium"
      >
        Copy Download Link
      </Button>
    </>
  )
}

export default DownloadReady
